/**
 * Announcement Bar component script
 * Handles announcement bar functionality including Swiper carousel and sticky behavior
 */
document.addEventListener('DOMContentLoaded', function () {
  const announcementBar = document.querySelector('[data-announcement-bar]');
  if (!announcementBar) return;

  if (announcementBar.hasAttribute('data-sticky')) {
    const height = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);

    document.body.classList.add('has-sticky-announcement');
  }

  const swiperElement = document.querySelector('[data-announcement-swiper]');
  if (swiperElement && typeof Swiper !== 'undefined') {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 2,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        waitForTransition: true,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      watchSlidesProgress: true,
      on: {
        autoplayStop: function() {
          // Reiniciar autoplay si se detiene
          this.autoplay.start();
        }
      }
    });

    // Asegurar que el autoplay continúe
    if (swiper.autoplay) {
      swiper.autoplay.start();
    }
  }
});

